export enum Availability {
  Open = 'open',
  Closed = 'closed',
  ByAppointment = 'byAppointment'
}